import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/logos.png';
import _imports_1 from '@/assets/unlock-bg.png';
import _imports_2 from '@/assets/unlock-vip.png';
const _withScopeId = n => (_pushScopeId("data-v-73b7bd81"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
})], -1));
const _hoisted_3 = {
  class: "main"
};
const _hoisted_4 = {
  class: "container"
};
const _hoisted_5 = {
  style: {
    "width": "280px",
    "height": "320px",
    "text-align": "center"
  }
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "unlock"
};
const _hoisted_8 = {
  class: "unlock-content"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_10 = {
  class: "unlock-main"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-title"
}, "解锁信息", -1));
const _hoisted_12 = {
  class: "unlock-bg"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "unlock-vip"
}, null, -1));
const _hoisted_14 = {
  style: {
    "width": "580px"
  }
};
const _hoisted_15 = {
  class: "unlock-tips1"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "研可岸择校网上线后免费服务了上百万用户", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt10"
}, [/*#__PURE__*/_createTextVNode(" 过高成本无法长久运营，决定每位用户将 "), /*#__PURE__*/_createElementVNode("span", null, "收费1元 (拼团)")], -1));
const _hoisted_18 = {
  class: "mt10"
};
const _hoisted_19 = {
  class: "fl-center"
};
const _hoisted_20 = {
  class: "unlock-step"
};
const _hoisted_21 = {
  class: "fl-start-center"
};
const _hoisted_22 = {
  class: "unlock-step-top"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step1", -1));
const _hoisted_24 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "支付费用")], -1));
const _hoisted_27 = {
  class: "unlock-step-top ml10"
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step2", -1));
const _hoisted_29 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "复制订单号")], -1));
const _hoisted_32 = {
  class: "unlock-step-bottom mt20"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-bottom-title"
}, "step3", -1));
const _hoisted_34 = {
  class: "unlock-step-bottom-content fl-start-center"
};
const _hoisted_35 = {
  class: "mt40 fl-space-between-center"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-tips2"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "tips-title"
}, "Q：为什么我的订单号激活失效？"), /*#__PURE__*/_createElementVNode("div", {
  class: "tips-subtitle"
}, " A：拼团订单只有拼团成功后才能激活 ")], -1));
const _hoisted_37 = {
  class: "unlock-service"
};
const _hoisted_38 = {
  class: "unlock-service-code"
};
const _hoisted_39 = ["src"];
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-service-title"
}, "扫码联系客服", -1));
const _hoisted_41 = {
  class: "unlock"
};
const _hoisted_42 = {
  class: "unlock-content"
};
const _hoisted_43 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1
}, null, -1));
const _hoisted_44 = {
  class: "unlock-main"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-title"
}, "解锁信息", -1));
const _hoisted_46 = {
  class: "unlock-bg"
};
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "unlock-vip"
}, null, -1));
const _hoisted_48 = {
  style: {
    "width": "580px"
  }
};
const _hoisted_49 = {
  class: "unlock-tips1"
};
const _hoisted_50 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt10"
}, " 如您需要继续查询，可以扫下方二维码购买查询次数 ", -1));
const _hoisted_51 = {
  class: "fl-center"
};
const _hoisted_52 = {
  class: "unlock-step"
};
const _hoisted_53 = {
  class: "fl-start-center"
};
const _hoisted_54 = {
  class: "unlock-step-top"
};
const _hoisted_55 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step1", -1));
const _hoisted_56 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_57 = ["src"];
const _hoisted_58 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "支付费用")], -1));
const _hoisted_59 = {
  class: "unlock-step-top ml10"
};
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-title"
}, "step2", -1));
const _hoisted_61 = {
  class: "unlock-step-top-content fl-start-center"
};
const _hoisted_62 = ["src"];
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-top-text"
}, [/*#__PURE__*/_createElementVNode("div", null, "微信扫码"), /*#__PURE__*/_createElementVNode("div", {
  class: "mt5"
}, "复制订单号")], -1));
const _hoisted_64 = {
  class: "unlock-step-bottom mt20"
};
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-step-bottom-title"
}, "step3", -1));
const _hoisted_66 = {
  class: "unlock-step-bottom-content fl-start-center"
};
const _hoisted_67 = {
  class: "mt40 fl-center"
};
const _hoisted_68 = {
  class: "unlock-service"
};
const _hoisted_69 = {
  class: "unlock-service-code"
};
const _hoisted_70 = ["src"];
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unlock-service-title"
}, "扫码联系客服", -1));
const _hoisted_72 = {
  class: "upload"
};
const _hoisted_73 = {
  class: "dialog-footer"
};
import { ref, onMounted } from "vue";
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import Clipboard from "clipboard";
import { ElMessage, ElMessageBox } from "element-plus";
import "element-plus/theme-chalk/el-message-box.css";
import { connectUs, recordNumber, connectUsPopup, examineYear, vipBecomeDueTime, changeUnlock, activationVip, changeUnlockAugment, tipsVip, settledType } from "@/api/api";
import { decrypt } from "@/utils/parseDate";
import { useStore } from "vuex";
export default {
  __name: 'Home',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    // 激活新的会员
    async function onTipsClick() {
      if (unlockForm.value.yzOid == "") {
        ElMessage({
          message: "请填写E开头订单号",
          type: "warning",
          showClose: true
        });
        return;
      }
      buttonLoading.value = true;
      const result = await changeUnlockAugment(unlockForm.value);
      const deRes = JSON.parse(decrypt(result));
      console.log(deRes);
      if (deRes.status === 0) {
        location.reload();
        unlockForm.value.yzOid = "";
        ElMessage.success("激活成功!");
        buttonLoading.value = false;
        store.commit("setTipsDialog", false);
        callChildMethod();
      } else {
        ElMessage({
          message: deRes.msg,
          type: "warning",
          showClose: true
        });
        buttonLoading.value = false;
      }
    }
    function onTipsClose() {
      store.commit("setTipsDialog", false);
    }
    const tipsStep1 = ref("");
    const tipsStep2 = ref("");
    const tipsKeFuUrl = ref("");
    // 获取激活引导图片
    async function getTipsActivationVip() {
      try {
        const result = await tipsVip();
        if (result.status === 0) {
          let res = JSON.parse(result.result);
          console.log(res);
          tipsStep1.value = res.step1;
          tipsStep2.value = res.step2;
          tipsKeFuUrl.value = res.keFuUrl;
        }
      } catch (error) {
        // throw new Error(error)
      }
    }

    // 默认展示菜单
    const activeIndex = ref("school");
    onBeforeRouteUpdate(to => {
      activeIndex.value = to.name;
    });
    const handleImitate = item => {
      window.open(item.url, "_blank");
    };
    const handleSelect = item => {
      if (item == "open") {
        window.open("https://pingjia.ykakaoyan.cn", "_blank");
        return;
      }
      console.log(item, 'item');
      router.push(item);
    };
    function onSpecial() {
      ElMessageBox.confirm("感谢利之学姐对网站无偿提出的一些宝贵意见", {
        title: "特别感谢",
        type: "warning",
        center: true
      }).then(() => {}).catch(() => {
        ElMessage({
          type: "info",
          message: "已取消"
        });
      });
    }
    // 联系我们
    const connectUsdata = ref("");
    // 备案号
    const recordData = ref("");
    const dialogUrl = ref({
      content: "",
      tips: ""
    });
    // 展示激活弹框
    function onChangeUnlock() {
      if (store.state.isVip) {
        return;
      }
      store.commit("setUnlockDialog", true);
    }
    // 显示登录弹框
    onMounted(() => {
      activeIndex.value = route.name;
      window.localStorage.setItem("activeTab", route.name);
      store.commit("setActiveTab", route.name);
      // getTipsActivationVip();
      // getActivationVip();
      // getConnectUs();
      getRecordNumber();
      // getExamineYear();
      // 禁用登录弹窗
      store.commit("setLoginModel", false);
    });
    // 解锁按钮
    const buttonLoading = ref(false);
    // 解锁表单
    const unlockForm = ref({
      yzOid: ""
    });
    // 关闭解锁弹框
    function onUnlockClose() {
      store.commit("setUnlockDialog", false);
    }
    function toAgreement(params) {
      let url = router.resolve({
        path: `/school/agreement/agreement`,
        query: {
          type: params.type,
          name: params.name
        }
      }).href;
      window.open(url);
    }
    async function onUnlockClick() {
      if (unlockForm.value.yzOid == "") {
        ElMessage({
          message: "请填写E开头订单号",
          type: "warning",
          showClose: true
        });
        return;
      }
      buttonLoading.value = true;
      const result = await changeUnlock(unlockForm.value);
      const deRes = JSON.parse(decrypt(result));
      console.log(deRes);
      if (deRes.status === 0) {
        location.reload();
        unlockForm.value.yzOid = "";
        ElMessage.success("激活成功!");
        buttonLoading.value = false;
        getVipBecomeDueTime();
        store.commit("setUnlockDialog", false);
      } else {
        ElMessage({
          message: deRes.msg,
          type: "warning",
          showClose: true
        });
        buttonLoading.value = false;
      }
    }
    const step1 = ref("");
    const step2 = ref("");
    const keFuUrl = ref("");
    // 获取激活引导图片
    async function getActivationVip() {
      try {
        const result = await activationVip();
        if (result.status === 0) {
          let res = JSON.parse(result.result);
          console.log(res);
          step1.value = res.step1;
          step2.value = res.step2;
          keFuUrl.value = res.keFuUrl;
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    function onUid() {
      console.log(store.state.uid);
      const clipboard = new Clipboard(`.copy`);
      clipboard.on("success", () => {
        ElMessage.success("复制成功 !");
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        ElMessage.warning("该浏览器不支持自动复制!");
        clipboard.destroy();
      });
    }
    // 获取是否激活和会员到期时间
    async function getVipBecomeDueTime() {
      try {
        const result = await vipBecomeDueTime();
        const res = JSON.parse(decrypt(result));
        console.log(res);
        if (res.status === 0) {
          window.localStorage.setItem("uid", res.result.uid);
          store.commit("setUid", res.result.uid);
          window.localStorage.setItem("isOrganization", res.result.organization);
          store.commit("setOrganization", res.result.organization);
          window.localStorage.setItem("isSuperRole", res.result.superRole);
          store.commit("setSuperRole", res.result.superRole);
          window.localStorage.setItem("isVip", res.result.activated);
          store.commit("setIsVip", res.result.activated);
          window.localStorage.setItem("vipTime", res.result.vipExpireTime == null ? "" : res.result.vipExpireTime);
          store.commit("setVipTime", res.result.vipExpireTime == null ? "" : res.result.vipExpireTime);
        }
      } catch (error) {}
    }
    async function toSettled() {
      try {
        const result = await settledType();
        if (result.status === 0) {
          window.open(result.result, "_blank");
        }
      } catch (error) {
        // throw new Error(error)
      }
    }
    // 联系我们
    async function getConnectUs() {
      try {
        const data = await connectUs();
        if (data.status === 0) {
          connectUsdata.value = JSON.parse(data.result);
        }
      } catch (error) {}
    }
    // 备案号
    async function getRecordNumber() {
      try {
        const data = await recordNumber();
        if (data.status === 0) {
          recordData.value = data.result;
        }
      } catch (error) {}
    }
    const showAboutDialog = ref(false);
    function showAbout() {
      showAboutDialog.value = true;
    }
    async function getConnectUsPopup() {
      try {
        const data = await connectUsPopup();
        if (data.status === 0) {
          dialogUrl.value = data.result;
        }
      } catch (e) {}
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_CloseBold = _resolveComponent("CloseBold");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_link = _resolveComponent("el-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_router_view)])]), _createVNode(_component_el_dialog, {
        width: "320px",
        modelValue: showAboutDialog.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showAboutDialog.value = $event)
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          style: {
            "width": "240px",
            "height": "240px"
          },
          src: connectUsdata.value.content
        }, null, 8, _hoisted_6)])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.unlockDialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(store).state.unlockDialog = $event),
        width: "670",
        "align-center": "",
        "before-close": onUnlockClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
          onClick: onUnlockClose,
          color: "#f92f60",
          class: "no-inherit"
        }, {
          default: _withCtx(() => [_createVNode(_component_CloseBold)]),
          _: 1
        }), _hoisted_9, _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_button, {
          type: "success"
        }, {
          default: _withCtx(() => [_createTextVNode("限时优惠")]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
          src: step1.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_25), _hoisted_26])]), _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, [_createElementVNode("img", {
          src: step2.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_30), _hoisted_31])])]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
          class: "unlock-step-bottom-input",
          clearable: "",
          modelValue: unlockForm.value.yzOid,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => unlockForm.value.yzOid = $event),
          placeholder: "输入E开头订单号"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "unlock-step-bottom-button",
          color: "#f5c98f",
          dark: true,
          loading: buttonLoading.value,
          onClick: onUnlockClick
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])])])])])]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("img", {
          src: keFuUrl.value
        }, null, 8, _hoisted_39)]), _hoisted_40])])])])])])]),
        _: 1
      }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_41, [_createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.tipsDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(store).state.tipsDialog = $event),
        width: "670",
        "align-center": "",
        "before-close": onTipsClose
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createVNode(_component_el_icon, {
          onClick: onTipsClose,
          color: "#f92f60",
          class: "no-inherit"
        }, {
          default: _withCtx(() => [_createVNode(_component_CloseBold)]),
          _: 1
        }), _hoisted_43, _createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("div", _hoisted_48, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", null, [_createTextVNode(" 注意：您的查询次数已达到上限，详情可查看👉 "), _createVNode(_component_el_link, {
          style: {
            "font-weight": "bold"
          },
          type: "success",
          onClick: _cache[3] || (_cache[3] = $event => toAgreement({
            type: 8905,
            name: '用户协议'
          }))
        }, {
          default: _withCtx(() => [_createTextVNode("用户协议")]),
          _: 1
        })]), _hoisted_50]), _createElementVNode("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_hoisted_55, _createElementVNode("div", _hoisted_56, [_createElementVNode("img", {
          src: tipsStep1.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_57), _hoisted_58])]), _createElementVNode("div", _hoisted_59, [_hoisted_60, _createElementVNode("div", _hoisted_61, [_createElementVNode("img", {
          src: tipsStep2.value,
          class: "unlock-step-top-code"
        }, null, 8, _hoisted_62), _hoisted_63])])]), _createElementVNode("div", _hoisted_64, [_hoisted_65, _createElementVNode("div", _hoisted_66, [_createElementVNode("div", null, [_createVNode(_component_el_input, {
          class: "unlock-step-bottom-input",
          clearable: "",
          modelValue: unlockForm.value.yzOid,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => unlockForm.value.yzOid = $event),
          placeholder: "输入E开头订单号"
        }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
          class: "unlock-step-bottom-button",
          color: "#f5c98f",
          dark: true,
          loading: buttonLoading.value,
          onClick: onTipsClick
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])])])])])]), _createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createElementVNode("div", _hoisted_69, [_createElementVNode("img", {
          src: tipsKeFuUrl.value
        }, null, 8, _hoisted_70)]), _hoisted_71])])])])])])]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_72, [_createVNode(_component_el_dialog, {
        modelValue: _unref(store).state.numberDialog,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(store).state.numberDialog = $event),
        title: "查询次数过多",
        width: "530",
        "destroy-on-close": "",
        center: ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_73, [_createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = $event => _unref(store).state.numberDialog = false)
        }, {
          default: _withCtx(() => [_createTextVNode("关闭")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createTextVNode(" 每天最多查询100次，超过次数后需要24小时后再查，请查看 "), _createVNode(_component_el_link, {
          style: {
            "font-weight": "bold"
          },
          type: "success",
          onClick: _cache[6] || (_cache[6] = $event => toAgreement({
            type: 8905,
            name: '用户协议'
          }))
        }, {
          default: _withCtx(() => [_createTextVNode("👉用户协议")]),
          _: 1
        })])]),
        _: 1
      }, 8, ["modelValue"])])])]);
    };
  }
};